export default __webpack_public_path__ + "static/media/promocionAlarma1.0ebb31b3.png";